module.exports = __webpack_public_path__ + "static/0168fdbd971ec8ba03caddd3dbc8fc228624ae404a7ee474ddc6c3a8aa0cb91b-1ad9bcdfd7007823ecec2807a1f33515.jpeg";